import { ChangeRequestResultPage } from "@repo/ui";
import { type FC } from "react";

export interface IChangeRequestLoading {
	heading?: string;
}

const ChangeRequestLoading: FC<IChangeRequestLoading> = ({ heading }) => {
	return <ChangeRequestResultPage status="success" isLoading titleOverride={heading} />;
};

export default ChangeRequestLoading;
